import {useEffect, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/toolbar/Toolbar'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {
  DrawerMessenger,
  ActivityDrawer,
  InviteUsers,
  EditImagePerfil,
  ThemeModeProvider,
} from '../partials'
import {MenuComponent} from '../assets/ts/components'

import Swal from 'sweetalert2'
import {toAbsoluteUrl} from '../helpers'
const title = 'Prezado usuário'
const text = `Gostaríamos de informar que o sistema que você está prestes a utilizar é uma versão de teste, projetada exclusivamente para fins de avaliação e experimentação. É importante destacar que essa versão de teste não efetuará nenhuma alteração na base de dados original.
Nossa principal intenção ao disponibilizar essa versão de teste é permitir que você explore todas as funcionalidades e recursos do sistema, familiarizando-se com sua interface e obtendo uma experiência prática do seu potencial. Entretanto, é fundamental compreender que qualquer dado inserido ou alteração realizada durante esse teste não será refletido na base de dados original. A versão de teste é uma simulação isolada, em um ambiente controlado, que nos permite coletar informações valiosas sobre o desempenho, usabilidade e possíveis melhorias do sistema. Seu feedback é muito importante para nós e nos ajudará a aprimorar a versão final do produto, garantindo sua qualidade e confiabilidade.

Lembre-se de que, como se trata de um ambiente de teste, podem existir limitações ou bugs que ainda não foram corrigidos. Caso você encontre algum problema ou tenha alguma dúvida durante o uso do sistema, ficaremos gratos se puder nos fornecer esse feedback para que possamos aprimorar sua experiência.

Agradecemos sinceramente sua participação nesse teste do sistema. Sua contribuição é inestimável para nós e nos ajudará a desenvolver um produto excepcional. Estamos ansiosos para receber seus comentários e sugestões.

Caso você precise acessar a versão oficial do sistema para realizar operações ou atualizar dados na base de dados original, informaremos as instruções e procedimentos apropriados no momento adequado.

Agradecemos sua atenção e colaboração.`

const MasterLayout = () => {
  const location = useLocation()
  const localcookie = localStorage.getItem('cookie')
  const [cookie, setcookie] = useState(localcookie)

  useEffect(() => {
    if (cookie !== 'true') {
      Swal.fire({
        imageUrl: toAbsoluteUrl('/media/logos/ambipar_response_black.png'),
        imageWidth: 200,
        imageHeight: 'auto',
        title: title,
        html: `<p style="text-align: justify;">&nbsp;&nbsp;Gostaríamos de informar que o sistema que você está prestes a utilizar é uma versão de teste, projetada exclusivamente para fins de avaliação e experimentação. É importante destacar que essa versão de teste <b>não efetuará nenhuma alteração na base de dados original</b>.</p>
      <p style="text-align: justify;">&nbsp;&nbsp;Nossa principal intenção ao disponibilizar essa versão de teste é permitir que você explore todas as funcionalidades e recursos do sistema, familiarizando-se com sua interface e obtendo uma experiência prática do seu potencial. Entretanto, é fundamental compreender que qualquer dado inserido ou alteração realizada durante esse teste não será refletido na base de dados original. A versão de teste é uma simulação isolada, em um ambiente controlado, que nos permite coletar informações valiosas sobre o desempenho, usabilidade e possíveis melhorias do sistema. Seu feedback é muito importante para nós e nos ajudará a aprimorar a versão final do produto, garantindo sua qualidade e confiabilidade.</p>
      <p style="text-align: justify;">&nbsp;&nbsp;Lembre-se de que, como se trata de um ambiente de teste, podem existir limitações ou bugs que ainda não foram corrigidos. Caso você encontre algum problema ou tenha alguma dúvida durante o uso do sistema, ficaremos gratos se puder nos fornecer esse feedback para que possamos aprimorar sua experiência.</p>
      <p style="text-align: justify;">&nbsp;&nbsp;Agradecemos sinceramente sua participação nesse teste do sistema. Sua contribuição é inestimável para nós e nos ajudará a desenvolver um produto excepcional. Estamos ansiosos para receber seus comentários e sugestões.</p>
      <p style="text-align: justify;">&nbsp;&nbsp;Caso você precise acessar a versão oficial do sistema para realizar operações ou atualizar dados na base de dados original, informaremos as instruções e procedimentos apropriados no momento adequado.</p>
      <p style="text-align: justify;">&nbsp;&nbsp;Agradecemos sua atenção e colaboração.</p>`,

        width: '80%',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6',
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      })
    }
    setTimeout(() => {
      localStorage.setItem('cookie', 'true')
    }, 3000)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='page d-flex flex-row flex-column-fluid'>
          <AsideDefault />
          <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
            <HeaderWrapper />

            <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
              <Toolbar />
              <div className='post d-flex flex-column-fluid' id='kt_post'>
                <Content>
                  <Outlet />
                </Content>
              </div>
            </div>
            <Footer />
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        <RightToolbar />
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* CARREGAMENTO DE MODAIS DO TEMA  */}
        {/* begin:: Modals */}
        <InviteUsers />
        {/* <UpgradePlan /> */}
        <EditImagePerfil />
        {/* <AlertLogin /> */}
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
